import axios from "axios";
import { useEffect, useState } from "react";
import { REACT_APP_API_URL } from "../../config";
import { useNavigate, useParams } from "react-router-dom";
import Prompt from "./Prompt/index.jsx";
import Swal from "sweetalert2";
import soapNotePrompt from "./Prompt/soapNote.jsx";

const Grammetical = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [transcript, setTranscript] = useState(null);
  const [grammeticalState, setGrammeticalState] = useState("Show Transcript");
  const [soapNote, setSoapNote] = useState(null);
  const [showResults, setShowResults] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tokens, setTokens] = useState(5000);
  const [postContent, setPostContent] = useState(Prompt);
  const [showSoapScreen, setSoapScreen] = useState(false);
  const [soapPrompt, setSoapPrompt] = useState(soapNotePrompt);
  // const [regenerate,setRegenerate] = useState(false);

  const getTranscript = async () => {
    if (!showResults) {
      setShowResults(true);
    }
    // const regenerate = regenerate;
    setLoading(true);
    try {
      const response = await axios.post(
        `${REACT_APP_API_URL}/api2/${
          showSoapScreen ? "soapnote" : "grammetical"
        }/${id}`,
        // { cleanUpPrompt: postContent },
        { cleanUpPrompt: showSoapScreen ? soapPrompt : postContent, tokens: tokens, regenerate: true },
        {
          headers: new Headers({
            "ngrok-skip-browser-warning": "69420",
          }),
        }
      );

      if (response.data) {
        if(showSoapScreen){
          console.log(response);
          
          setSoapNote(response.data);
          
        } else {
          setTranscript(response.data);
        }
        // setTranscript(response?.data?.transcript?.split("\n"));
        // setSoapNote(response?.data?.soapNote?.split("\n"));
      } else {
        const errorMessage = response?.data?.error || "Something went wrong!";
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: errorMessage,
        });
      }
    } catch (error) {
      console.log("error: ", error);
      
      const errorMessage = `${error?.response?.data?.error}`;
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error?.response?.data?.error
          ? errorMessage
          : `status code: ${
              error?.response?.status ? error?.response?.status : "server down/"
            } \n something went wrong`,
      });
    } finally {
      setLoading(false);
      // setRegenerate(true)
    }
  };

  return (
    <>
      <div className="cleanup">
        {showSoapScreen ? "Dr. SOAP Note" : "Grammetical"}
      </div>

      {loading && <img src="/process.gif" alt="loading..." />}

      {!loading && (
        <>
          <div className="input-container">
            <button
              className="btn"
              onClick={() => {
                setSoapScreen((prev) => !prev);
              }}
            >
              {showSoapScreen ? "Generate SOAP Note" : "Generate Transcript"}
            </button>
            <label htmlFor="postContent" className="input-label">
              Write your Prompt:
            </label>
            <textarea
              id="postContent"
              name="postContent"
              value={showSoapScreen ? soapPrompt : postContent}
              onChange={(e) => {
                showSoapScreen
                  ? setSoapPrompt(e.target.value)
                  : setPostContent(e.target.value);
              }}
              rows={10}
              cols={50}
              className="input-textarea"
            />
          </div>

          <div className="input-generate">
            <label htmlFor="tokens">Tokens: </label>
            <input
              type="number"
              name="tokens"
              value={tokens}
              min={500}
              className="input-num"
              max={16384}
              onChange={(e) => setTokens(e.target.value)}
            />
            <button
              className="btn generate-btn"
              onClick={getTranscript}
              disabled={loading}
            >
              Generate
            </button>
          </div>

          {showResults && (
            <div>
              {/* <button
                className="btn grammerbtn"
                onClick={() =>
                  setGrammeticalState((prev) =>
                    prev === "Show Transcript"
                      ? "Show SOAP Note"
                      : "Show Transcript"
                  )
                }
              >
                {grammeticalState}
              </button> */}
              <button className="btn back" onClick={() => navigate("/")}>
                Back
              </button>

              {!showSoapScreen ? (
                <>
                  {transcript?.length ? (
                     <div className="grammer">
                    {transcript.map((trans, i) => (
                      <p key={i}>
                        {trans.speaker}: {trans.text.join(" ")}
                      </p>
                      // <p key={i}>{trans.replaceAll("*", "").replaceAll("#", "").replaceAll("---", "")}</p>
                    ))
                    }
                    </div>
                  ) : (
                    <p className="msg">No Clean Up Transcript is Available</p>
                  )}
                </>
              ) : (
                <>
                  {soapNote?.length ? (
                    <div className="grammer">
                      {soapNote?.split("\n")?.map((soap, i) => {
                        return (
                          <p key={i}>{soap.replaceAll("*", "").replaceAll("#", "").replaceAll("-", "")}</p>
                        )
                        })
                      }
                    </div>
                    
                  ) : (
                    <></>
                  )}
                </>
              )}
            </div>
          )}
          {/* <button className="btn back" onClick={() => navigate("/")}>
            Back
          </button> */}
        </>
      )}
    </>
  );
};

export default Grammetical;
